import * as React from "react";
export class FormError extends React.PureComponent {
    render() {
        if (!this.props.visible) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: "rj-forgot-password__error-field" }, this.props.message));
    }
}
//# sourceMappingURL=FormError.js.map